import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {AngularJsMaterialModuleName, UtilsModuleName} from "../utils/names/requiredModulesNames";
import {
    BrandServiceModuleName,
    InstanceConfigurationModuleName,
    MD_COLOR_PICKER_MODULE_NAME,
    ThemeColourPickerModuleName
} from "../utils/names/optionalModuleNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {getTabName} from "modules/utils/TabNameUtils";

export const InstanceConfigurationModuleConfiguration = new RestrictedRouteModuleConfiguration(
    UserGranredAuthorityName.INSTANCE_CONFIGURATION,
    [
        InstanceConfigurationModuleName,
        ThemeColourPickerModuleName,
        UtilsModuleName,
        BrandServiceModuleName,
        MD_COLOR_PICKER_MODULE_NAME,
        AngularJsMaterialModuleName
    ],
    [
        ["/configuration", {
            template: require("./route/configuration.html"),
            controller: 'configurationController',
        }]
    ],
    [
        new NavigationItem({
            title: "Configuration",
            href: "#!configuration",
            accessRole: [NavigationAccessRoles.ROLE_ADMIN],
            activeFunction: routeName => routeName.indexOf("configuration") !== -1
        })
    ],
    [InstanceConfigurationModuleName],
    [UserGranredAuthorityName.INSTANCE_CONFIGURATION],
    getTabName() + '| Instance Configuration'
);

export default InstanceConfigurationModuleConfiguration;